/**
 * Tracks the "client version is too old" signal from the API.
 *
 * Populated by `baseQuery` when an HTTP 426 lands; consumed by
 * `UpdateRequiredModal` to render the blocking modal. Once flipped to
 * `required: true` there's no way back — the user has to reload.
 */

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface UpdateRequiredState {
  required: boolean;
  clientVersion: string | null;
  minServerVersion: string | null;
}

const initialState: UpdateRequiredState = {
  required: false,
  clientVersion: null,
  minServerVersion: null,
};

export const updateRequiredSlice = createSlice({
  name: 'updateRequired',
  initialState,
  reducers: {
    markRequired(
      state,
      action: PayloadAction<{ clientVersion?: string | null; minServerVersion?: string | null }>,
    ) {
      state.required = true;
      state.clientVersion = action.payload.clientVersion ?? state.clientVersion;
      state.minServerVersion = action.payload.minServerVersion ?? state.minServerVersion;
    },
  },
});

export const { markRequired } = updateRequiredSlice.actions;
export const updateRequiredReducer = updateRequiredSlice.reducer;
